'use strict';

exports.__esModule = true;
exports.widget = undefined;

var _concat = require('babel-runtime/core-js/array/concat');

var _concat2 = _interopRequireDefault(_concat);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _widgetActions = require('../actions/widget-actions');

var _transformators = require('../utils/transformators');

var _constats = require('../utils/constats');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var INITIAL_STATE = {};

var totalRecommendationsForOneDoctor = function totalRecommendationsForOneDoctor(state) {
    return state.specialists && +state.specialists.find(function (item) {
        return state.activeSpecialist && item.id === state.activeSpecialist.id || state.profileType && state.profileType === _constats.QUERY_SPECIALISTS_PROFILE_TYPE && state.profileId && (item.id === state.profileId || item.uri_id === state.profileId);
    }).totalRecommendations;
};

var widget = exports.widget = function widget(state, action) {
    switch (action.type) {
        case _widgetActions.SET_TAB:
        case _widgetActions.GET_LAYOUT:
        case _widgetActions.SET_OFFSET:
        case _widgetActions.SET_SPECIALIST:
        case _widgetActions.SET_REVIEWS_LIMIT:
        case _widgetActions.GET_PROFILE_DETAILS:
        case _widgetActions.SET_RECOMMENDATIONS_LIMIT:
            return (0, _extends3.default)({}, state, action.payload);
        case _widgetActions.LOAD_REVIEWS_STAT_FOR_ONE + '_RECEIVED':
            return (0, _extends3.default)({}, state, {
                averageRating: +action.response.average_rating,
                totalReviews: +action.response.total_reviews
            });

        case _widgetActions.LOAD_REVIEWS_FOR_ONE + '_RECEIVED':
            return (0, _extends3.default)({}, state, {
                reviews: (0, _transformators.transformOneProfileReviews)(action.response.reviews)
            });
        case _widgetActions.LOAD_PRACTICE + '_RECEIVED':
            var transformedPractice = (0, _transformators.transformPractice)(action.response.practice);
            return (0, _extends3.default)({}, state, {
                practice: transformedPractice,
                specialists: (0, _concat2.default)([{ id: undefined, name: 'All doctors' }], (0, _transformators.transformPracticeSpecialists)(action.response.specialists))
            });
        case _widgetActions.LOAD_SPECIALIST + '_RECEIVED':
            return (0, _extends3.default)({}, state, {
                practice: undefined,
                specialists: (0, _concat2.default)([{ id: undefined, name: 'All doctors' }], (0, _transformators.transformPracticeSpecialists)([{ specialist: action.response.specialist }])),
                totalRecommendations: action.response.specialist.number_of_recommendations
            });
        case _widgetActions.LOAD_REVIEWS_FOR_ALL_DOCTORS + '_RECEIVED':
            return (0, _extends3.default)({}, state, {
                reviews: (0, _transformators.transformAllDoctorsReviews)(action.response.reviews)
            });
        case _widgetActions.LOAD_REVIEWS_STAT_FOR_ALL_DOCTORS + '_RECEIVED':
            return (0, _extends3.default)({}, state, {
                totalReviews: +action.response.count
            });
        case _widgetActions.LOAD_RECOMMENDATIONS_FOR_ONE_DOCTOR + '_RECEIVED':
            return (0, _extends3.default)({}, state, {
                recommendations: (0, _transformators.transformRecommendations)(action.response),
                totalRecommendations: totalRecommendationsForOneDoctor(state)
            });
        case _widgetActions.LOAD_RECOMMENDATIONS_FOR_ALL_DOCTORS + '_RECEIVED':
            return (0, _extends3.default)({}, state, {
                recommendations: (0, _transformators.transformRecommendations)(action.response.peer_recommendations)
            });
        case _widgetActions.LOAD_RECOMMENDATIONS_STAT_FOR_ALL_DOCTORS + '_RECEIVED':
            return (0, _extends3.default)({}, state, {
                totalRecommendations: +action.response.count
            });
        default:
            return state || INITIAL_STATE;
    }
};